module.exports = __webpack_public_path__ + "static/media/cameron-highlands.50e7b016.jpeg";